/** Prefix for DevTools filter: `[ff-voice-bridge]` */
const LOG_PREFIX = '[ff-voice-bridge]';

/** Kept for optional sandbox tooling; voice bridge is exercised via console + ModTools. */
export const isVoiceBridgeDebugMode = false;

function getSendMessageToUnity(): ((g: string, m: string, p?: string | number) => void) | undefined {
  if (typeof window === 'undefined') return undefined;
  const fn = (window as unknown as { sendMessageToUnity?: (g: string, m: string, p?: string | number) => void })
    .sendMessageToUnity;
  return typeof fn === 'function' ? fn : undefined;
}

/**
 * Sends PlayerMute / PlayerUnmute to Unity BrowserBridge.
 * Always logs to console.info / console.warn so you can verify delivery without enabling app logger.
 */
export function sendPlayerVoiceMuteUnmute(
  eventType: 'PlayerMute' | 'PlayerUnmute',
  userId: string,
  source: string
): boolean {
  const trimmed = userId.trim();
  const send = getSendMessageToUnity();
  const hasBridge = Boolean(send);
  console.info(LOG_PREFIX, source, eventType, {
    userId: trimmed,
    hasSendMessageToUnity: hasBridge,
    hasUnityInstance: typeof window !== 'undefined' && Boolean((window as unknown as { unityInstance?: unknown }).unityInstance),
  });
  if (!trimmed) {
    console.warn(LOG_PREFIX, source, 'empty userId');
    return false;
  }
  if (!send) {
    console.warn(LOG_PREFIX, source, 'sendMessageToUnity not available (Unity not loaded yet?)');
    return false;
  }
  const envelope = JSON.stringify({
    eventType,
    payload: JSON.stringify({ userId: trimmed }),
  });
  try {
    send('BrowserBridge', 'ReceivePayload', envelope);
    console.info(LOG_PREFIX, source, 'ReceivePayload dispatched', envelope);
    return true;
  } catch (e) {
    console.error(LOG_PREFIX, source, 'SendMessage threw', e);
    return false;
  }
}
